import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLayoutUpdate } from '../../../../context/LayoutProvider/LayoutProvider';
import NioButton from '../../../NioButton/NioButton';
import LanguageSwitcher from '../../../LanguageSwitcher/LanguageSwitcher';
import { useTranslation } from '../../../../i18n/I18nProvider';

function getStoredUser() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export default function HeaderAction({ buttonContent, className, nioBtnClasses, nioToggleClasses }) {
  const layoutUpdate = useLayoutUpdate();
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(getStoredUser);
  const { t } = useTranslation();

  useEffect(() => {
    setUser(getStoredUser());
  }, [location.pathname]);

  const handleLogout = (e) => {
    e?.preventDefault?.();
    localStorage.removeItem('user');
    setUser(null);
    navigate('/');
  };

  return (
    <div className={className}>
      <ul className="nk-btn-group sm justify-content-end flex-nowrap gap-1 gap-lg-2">
        <li className="d-none d-lg-block">
          <LanguageSwitcher />
        </li>
        {user ? (
          <>
            <li className="d-none d-lg-block">
              <NioButton
                href="/profile"
                icon="user"
                label={t('nav.myAccount')}
                className={`${nioBtnClasses} text-nowrap btn-sm`}
              />
            </li>
            <li className="d-none d-lg-block">
              <NioButton
                href="/profile#payments"
                label={t('nav.myPayments')}
                className={`${nioBtnClasses} text-nowrap btn-sm`}
              />
            </li>
            <li className="d-none d-lg-block">
              <NioButton
                label={t('nav.logout')}
                className={`${nioBtnClasses} text-nowrap btn-sm`}
                onClick={handleLogout}
              />
            </li>
          </>
        ) : (
          <li className="d-none d-lg-block">
            <NioButton
              href={buttonContent?.redirect || '/auth/login'}
              icon={buttonContent?.icon || 'user'}
              label={buttonContent?.label || t('nav.login')}
              className={`${nioBtnClasses} text-nowrap btn-sm`}
            />
          </li>
        )}
        <li className="nk-navbar-toggle">
          <NioButton
            icon="menu"
            className={nioToggleClasses}
            onClick={layoutUpdate.headerMobile}
          />
        </li>
      </ul>
    </div>
  );
}
